import React from 'react'
import { Typography } from '@xprog/prensa'
import * as t from './Tag.types'
import * as S from './Tag.styled'

const Tag: React.FC<t.TagProps> = (props) => {
  const { wrapLink: TagWrap } = props
  const renderTag = () => (
    <Typography
      {...props.default}
      {...props.customProps}
      css={{
        ...props.defaultCss,
        ...props.customCss
      }}
    >
      {props.value || props.children}
    </Typography>
  )
  if (props.wrapLink) {
    return (
      <S.Container customCss={props.cssContainer}>
        <TagWrap {...props}>{renderTag()}</TagWrap>
      </S.Container>
    )
  } else {
    return (
      <S.Container customCss={props.cssContainer}>{renderTag()}</S.Container>
    )
  }
}

Tag.defaultProps = {
  defaultCss: {
    backgroundColor: '#DEDEDE',
    color: '#000000',
    fontFamily: '$primary',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '17px',
    py: '$1',
    px: '$3',
    mt: '$0',
    mr: '$2',
    mb: '$2',
    // width: 'max-content'
  }
}

export default Tag
